export default 'skill-bite-edit'
